export default __webpack_public_path__ + "static/media/decoration.916c3fa0.png";